import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

type Props = {
  subjectId?: number;
  subjectTitle?: string;   // <-- already here
  maxGroups?: number;
  buttonClassName?: string;
};

export function StudyChatLauncher({ subjectId, subjectTitle, buttonClassName }: Props) {
  const navigate = useNavigate();
  return (
    <Button
      variant="outline"
      className={buttonClassName ?? 'h-10 w-full'}
      onClick={() => {
        if (!subjectId) {
          navigate('/study'); // dev fallback
          return;
        }
        const q = subjectTitle ? `?title=${encodeURIComponent(subjectTitle)}` : '';
        navigate(`/study/${subjectId}${q}`);
      }}
    >
      Study Group
    </Button>
  );
}

export default StudyChatLauncher;
